import { Device, Partners } from 'utils/constants';

export const getLabels = (modelType: string) => {
    if (modelType === Device.MOBILE || modelType === Device.TABLET) {
        return {
            customer: {
                title: 'Enter Customer Details',
                nameLabel: 'Full Name',
                mobileLabel: 'Mobile Number',
                emailLabel: 'Email',
            },
            device: {
                title: 'Enter Device Details',
                imeilabel: 'IMEI number',
                verifyLabel:
                    'I have verified the IMEI number for plan issuance',
            },
            promoter: {
                title: 'Enter Promoter Id',
                promoterIdLabel: 'Promoter Id',
            },
        };
    }
    return {
        customer: {
            title: 'Customer',
            nameLabel: 'Full Name',
            mobileLabel: 'Mobile Number',
            emailLabel: 'Email',
        },
        device: {
            title: 'Device',
            imeilabel: 'Serial Number',
            verifyLabel: 'I have verified the serial number',
        },
        promoter: {
            title: 'Enter Promoter Id',
            promoterIdLabel: 'Promoter Id',
        },
    };
};

export const isValidIMEI = (imei: string, partnerId?: string) => {
    if (partnerId === Partners.HERO_VIDA) {
        return true;
    }
    if (partnerId === Partners.REALME) {
        return imei.length >= 8 && imei.length <= 20;
    }
    if (partnerId === Partners.XIAOMI) {
        if (imei.trim().length === 0) {
            return false;
        }
        const mobileValidation = imei?.length === 15 && /^[0-9]+$/.test(imei);
        const televisionValidation =
            /^[A-Za-z0-9]{5}\/[A-Za-z0-9]{12,13}$/.test(imei);
        return mobileValidation || televisionValidation;
    }
    if (imei?.length === 15 && /^[0-9]+$/.test(imei)) return true;
    return false;
};

export const isEWPlan = (planId: string) => {
    try {
        return planId?.includes('_ew');
    } catch {
        return false;
    }
};
